import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import moment from 'moment';
import { SESSION_TIMEOUT_MINUTES, TOKEN_DATE_KEY } from './constants';

interface AuthVerifyProps {
  logOut: (showNotification?: boolean) => void;
}

const AuthVerify: React.FC<AuthVerifyProps> = ({ logOut }) => {
  const history = useHistory();

  useEffect(() => {
    // Escuchar cambios de ruta
    const unlisten = history.listen(() => {
      const tokenTime = localStorage.getItem(TOKEN_DATE_KEY);

      if (tokenTime) {
        const lastActivity = moment(tokenTime);
        const minutesInactive = moment().diff(lastActivity, 'minutes');

        if (minutesInactive >= SESSION_TIMEOUT_MINUTES) {
          // Inactividad excedida: cerrar sesión
          logOut(true);
        } else {
          // Actualizar tiempo de última actividad
          localStorage.setItem(TOKEN_DATE_KEY, moment().toString());
        }
      }
    });

    return () => unlisten();
  }, [history, logOut]);

  return null;
};

export default AuthVerify;
